var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-header"},[_c('div',{staticClass:"about-header__content"},[_c('h2',{staticClass:"about-header__title"},[_vm._v("关于")])]),_c('div',{staticClass:"about-header__banner"},[_c('img',{attrs:{"src":"http://cdn.airfunc.com/undraw_working_from_anywhere_ub67.svg"}})])])
}]

export { render, staticRenderFns }